import { Box } from "@mui/system";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";

export const PageError = () => {
  return (
    <Fragment>
      <Box className="p-8">
        {/* Header */}

        <Box className="items-center py-24 md:py-0">
          <Box className="text-center ">
            <div className="text-base md:text-2xl font-aref ">
              <img src="asset/lost.png" alt="lost" className="h-full mx-auto" />
              Oops.... Looks like you're lost, Let's help you go back to
              <Link to={"/"} className="underline ml-2 text-secondary">
                Homepage
              </Link>
            </div>
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};
